import { z } from "zod";

export const MemoryFactNodeContentSchema = z.object({
  nodeType: z.literal("memory"),
  version: z.literal("1"),
  content: z.string().max(4096),
  pinned: z.boolean().optional(),
});

export const MemoryFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("memory"),
  version: z.literal("1"),
});

export type MemoryFactNode = z.infer<typeof MemoryFactNodeContentSchema>;
